import { useTranslation } from "react-i18next"
import { observer } from "mobx-react-lite"
import { IEventCollectionItem } from "../../interfaces"
import { ScrollList, Text } from "../."
import { BadgeCard } from "./BadgeCard"

interface IPastEventProps {
	events: IEventCollectionItem[]
}

export const PastEvents = observer(({ events }: IPastEventProps) => {
	const { t } = useTranslation()

	return (
		<div className="ml-[16px]">
			<div>
				<Text variant="normal-bold" style="">
					{t("home.past")}
				</Text>
			</div>

			<ScrollList items={events} renderItem={(item) => <BadgeCard event={item} />} />
		</div>
	)
})
